export const LEVEL_NAMES: Record<number, string> = {
    1: "Новачок",
    2: "В темі",
    3: "Спонсор",
    4: "Еліта",
    5: "Легенда",
};

export const MAX_LEVEL = 5;

// Рівень гравця за його особистим бонусом (1..5)
export const getLevel = (user) => Math.min((user.personalBonus + 1) || 1, MAX_LEVEL);

const LevelBlock = ({ user }) => {
    const level = getLevel(user);

    return (
        <div className="pb-level-chip">
            <span className="pb-level-num">{level}</span>
            <span className="pb-level-name">{LEVEL_NAMES[level]}</span>
        </div>
    );
};

export default LevelBlock;
